import React, { useState } from 'react';
import './adminlogin.css'
import usericon from '../../../icon/user.png'
import passwordicon from '../../../icon/password.png'

export default function Adminlogin(props) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
  
    const handleLogin = async (e) => {
      e.preventDefault();
      try {
        const response = await fetch('http://185.164.73.170:5000/adminlogin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username, password }),
        });
  
        if (response.status === 200) {
          props.setLoggedIn(true);
        } else {
          setError('اطلاعات وارد شده صحیح نمی باشد');
        }
      } catch (err) {
        setError('مشکل از سمت سرور');
      }
    };
  
    return (
      <div className='adminlogin'>
        <h2>Admin</h2>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <form onSubmit={handleLogin}>
          <div style={{display: 'flex' , justifyContent: 'center' , alignItems: 'center' , direction: 'ltr'}}>
          <img src={usericon} alt='username'></img><input 
            type="text"
            placeholder="Username"
            value={username} 
            onChange={(e) => setUsername(e.target.value)} 
          />
          </div>
          <div style={{display: 'flex' , justifyContent: 'center' , alignItems: 'center' , direction: 'ltr'}}>
          <img src={passwordicon} alt='password'></img><input 
            type="password" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
          />
          </div>
          <button type="submit">Login</button>
        </form>
      </div>
    );
  
};